module.exports = __webpack_public_path__ + "img/resources-375.a2fc6e98.jpg";